import { mergeDeep, crossBrowserFocus } from '../util';
import { FC_Accessibility_Base, FC_Accessibility_LegendEnabled } from './legendEnabled';

class FC_Accessibility_SingleSeries extends FC_Accessibility_Base {
  constructor(svgRoot, chartInstance, alternateTexts, config) {
    super(svgRoot, chartInstance, alternateTexts, config);
  }

  /**
   * Make single series chart accessible
   */
  makeSingleSeriesAccessible() {

    let dataLength = (this.chartType === 'angulargauge') ? this.chartData.dials.dial.length : this.chartData.data.length;
    let plotData;
    switch (this.chartType) {
      case 'pyramid':
      case 'funnel':
        plotData = this.chartInstance.apiInstance.getDatasets()[0]._components.data;
        break;
      default:
        plotData = this.chartInstance.apiInstance.getDatasets()[0].components.data;
        break;
    }


    let getPlotElement = (plot) => {
      switch (this.chartType) {
        case 'pyramid':
        case 'funnel':
          return plot._graphics.graphic;
        case 'angulargauge':
          if (plot.graphics.pointersTpath.data('eventArgs')) {
            return plot.graphics.pointersTpath;
          }
          return plot.graphics.pointersPath;
        default:
          return plot.graphics.element;
      }
    };

    let firstElementIndex = -1;

    let addAria = function () {

      let getPlotStats = (plotConfig, i) => {
        let plotStat = {};

        //label
        plotStat['{label}'] = plotConfig.label || plotConfig.categoryLabel || plotConfig.dataLabel || '';
        //value
        plotStat['{value}'] = plotConfig.y || plotConfig.setValue || 0;
        plotStat['{formattedValue}'] = plotConfig.formatedVal || this.chartInstance.formatNumber(plotStat['{value}']) || '';
        plotStat['{plotIndex}'] = i + 1;
        plotStat['{totalPlots}'] = plotData.length;
        plotStat['{percentValue}'] = plotConfig.pValue;

        return plotStat;
      }

      /**
       * Add aria values to a plot with given index
       *
       * There may be cases where data is null in chart data, in such cases dom is not renereded
       * i denotes the index of plot in chart data
       *
       * The correct dom index for next plot is returned from function, if the data is found to be invalid then current dom element is matched for next data
       * @param {*} i
       *
       */
      let plotIterator = (i) => {
        let alternateTextsPlot;
        if (plotData[i]) {
          let plotElem = getPlotElement(plotData[i])
          if (plotElem) {
            if (firstElementIndex == -1) firstElementIndex = i;
            let plotStats = undefined;
            if (this.chartType == "pyramid" || this.chartType == "funnel") {
              plotStats = getPlotStats(plotData[i], i);
            } else {
              plotStats = getPlotStats(plotData[i].config, i);
            }
            alternateTextsPlot = this.alternateTexts.plot;
            if ((plotData[i].config.setLink && plotData[i].config.setLink !== "") || (plotData[i].config.link && plotData[i].config.link !== "") || (plotData[i].link && plotData[i].link !== "")) {
              alternateTextsPlot += " This is a clickable plot";
            }

            this.addTabIndexAndSetAria(plotElem.node, alternateTextsPlot, mergeDeep(this.chartPropertyMap, plotStats), firstElementIndex == i ? "0" : "-1");
          }
        }
      };

      for (let i = 0; i < dataLength; i++) {
        plotIterator(i);
      }

      if (this.chartType == 'waterfall2d') {
        plotIterator(dataLength);
      }
    }.call(this);

    let plotIndex = -1;
    function plotSelectOnKeyPress(event) {
      let keyCaptured = false, elemVisible = false;
      let loopCount = 0;
      let plotLength = dataLength - 1;
      if (this.chartType == 'waterfall2d') {
        plotLength = dataLength;
      }
      while (!elemVisible && loopCount < dataLength) {
        ++loopCount;
        switch (event.keyCode) {
          case 37:
          case 38:
            //left arrow and down arrow
            --plotIndex;
            if (plotIndex < 0) {
              plotIndex = plotLength;
            }
            keyCaptured = true;
            break;
          case 39:
          case 40:
            //right arrow and up arrow
            ++plotIndex;
            if (plotIndex > plotLength) {
              plotIndex = 0;
            }
            keyCaptured = true;
            break;
          case 13:
          //Enter
          case 32:
            //spacebar
            if (this.chartInstance.apiInstance.getDatasets()[0]._firePlotEvent) {
              this.chartInstance.apiInstance.getDatasets()[0]._firePlotEvent('fc-click', plotIndex < 0 ? 0 : plotIndex, new Event('click'));
            } else if (this.chartType === 'angulargauge') {
              if (this.chartInstance.apiInstance.getDatasets()[0].components.data[plotIndex < 0 ? 0 : plotIndex].graphics.pointersTpath.data('eventArgs')) {
                this.chartInstance.apiInstance.plotEventHandler(this.chartInstance.apiInstance.getDatasets()[0].components.data[plotIndex < 0 ? 0 : plotIndex].graphics.pointersTpath, new Event('click'));
              } else {
                this.chartInstance.apiInstance.plotEventHandler(this.chartInstance.apiInstance.getDatasets()[0].components.data[plotIndex < 0 ? 0 : plotIndex].graphics.pointersPath, new Event('click'));
              }
            } else if (this.chartType === 'funnel' || this.chartType === 'pyramid') {
              this.chartInstance.apiInstance.plotEventHandler(this.chartInstance.apiInstance.getDatasets()[0]._components.data[plotIndex < 0 ? (this.chartType === 'funnel' ? 1 : 0) : plotIndex]._graphics.trackerObj, new Event('click'));
            }
            // keyCaptured = true;
            break;
        }
        if (keyCaptured) {
          event.preventDefault();
          if (plotData[plotIndex]) {
            let plotElem = getPlotElement(plotData[plotIndex]);
            if (plotElem) {
              if (document.activeElement == plotElem.node) continue;

              crossBrowserFocus(plotElem.node);
              elemVisible = true;
            }
          }
        }
        else break;
      }
    }

    this.svgRoot.addEventListener('keydown', plotSelectOnKeyPress.bind(this), false);
  }
}

class FC_Accessibility_SingleSeriesWithLegend extends FC_Accessibility_LegendEnabled {
  constructor(svgRoot, chartInstance, alternateTexts, config) {
    super(svgRoot, chartInstance, alternateTexts, config);
  }

  /**
   * Make single series chart with legend accessible
   */
  makeSingleSeriesWithLegendAccessible() {
    this.makeLegendAccessible();

    let accessibleSingleSeries = new FC_Accessibility_SingleSeries(this.svgRoot, this.chartInstance, this.alternateTexts, this.config);
    accessibleSingleSeries.makeSingleSeriesAccessible();
  }
}

export { FC_Accessibility_SingleSeries, FC_Accessibility_SingleSeriesWithLegend };